<template>
  <div>
    <!-- ##### ToolBar ##### -->
    <v-toolbar :flat="scrollY == 0 && isMobile" app :color="tournee && tournee.couleur"> 
      <v-toolbar-title>{{tournee && tournee.libelle}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="closeTournee()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- ##### Contenu ##### -->
    <v-content v-scroll="onScroll">
      <v-container :class="{'pa-0': isMobile, 'padding-for-fab':isMobile}"> 
        <v-layout wrap>
          <v-flex xs12 md6 :px-2="!isMobile">
            <CardPlus>
              <TourneesDetailsList 
                title="Eleveurs à voir"
                :id-tournee="+$route.params.id"
                :voirChecked="false">
                <v-alert slot="no-data" :value="true" color="info" icon="info" outline class="mx-2">
                  Bravo vous avez vu tous les éleveurs
                </v-alert>
              </TourneesDetailsList>
            </CardPlus>
          </v-flex>
          <v-flex xs12 md6 :px-2="!isMobile">
            <CardPlus>
              <TourneesDetailsList 
                title="Eleveurs déjà vu"
                :id-tournee="+$route.params.id"
                :voirChecked="true">
                <v-alert slot="no-data" :value="true" color="info" icon="info" outline class="mx-2">
                  Sélectionner les éleveurs lorsque vous les avez vus
                </v-alert>
              </TourneesDetailsList>
            </CardPlus>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <!-- ##### Menu édition de la tournée ##### -->
    
    <v-fab-transition>
      <v-bottom-sheet inset v-model="sheet">
        <v-btn
          slot="activator"
          :color="tournee && tournee.couleur"
          fab
          fixed
          bottom
          right>
          <v-icon>print</v-icon>
        </v-btn>
        <TourneesDetailsEdition 
          :id-tournee="+$route.params.id"
          :etat="sheet"
          @close-bottom="sheet = false"/>
      </v-bottom-sheet>
    </v-fab-transition>
    
  </div>
</template>

<script>
import TourneesDetailsList from '@/components/TourneesDetailsList'
import TourneesDetailsEdition from '@/components/TourneesDetailsEdition'
import CardPlus from '@/components/CardPlus'

export default {
  components: {
    TourneesDetailsList,
    TourneesDetailsEdition,
    CardPlus
  },
  data: () => ({
    scrollY : 0,
    sheet: false
  }),
  computed: {
    tournee(){
      return this.$store.state.tournees.find(e=>e.id == +this.$route.params.id)
    }
  },
  methods: {
    onScroll(){
      this.scrollY = window.scrollY
    },
    closeTournee(){
      this.$router.go('-1');
    }
  }
}
</script>

<style scoped>
  .padding-for-fab>div {
    padding-bottom: 80px;
  }
</style>

<style>
  .v-dialog.v-bottom-sheet.v-bottom-sheet--inset.v-dialog--active{
    overflow-y: auto;
  }
</style>
